import { render, staticRenderFns } from "./AssessDetail.vue?vue&type=template&id=1a4d2b7a&scoped=true"
import script from "./AssessDetail.vue?vue&type=script&lang=js"
export * from "./AssessDetail.vue?vue&type=script&lang=js"
import style0 from "./AssessDetail.vue?vue&type=style&index=0&id=1a4d2b7a&prod&media=print&lang=css"
import style1 from "./AssessDetail.vue?vue&type=style&index=1&id=1a4d2b7a&prod&scoped=true&lang=scss"
import style2 from "./AssessDetail.vue?vue&type=style&index=2&id=1a4d2b7a&prod&lang=css"
import style3 from "./AssessDetail.vue?vue&type=style&index=3&id=1a4d2b7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d2b7a",
  null
  
)

export default component.exports